import { IElement } from "core-integration/src/store/elements/types";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  ArrowLeft,
  ArrowLeftDouble,
  ArrowRight,
  ArrowRightDouble,
} from "../icons/Arrows";
import PaginatorButton from "../paginator/PaginatorButton";

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.space[2]};
`;

export const paginate = (
  elements: IElement[],
  page: number,
  pageSize: number,
) => {
  const start = (page - 1) * pageSize;
  return {
    data: elements.slice(start, start + pageSize),
    totalPages: Math.ceil(elements.length / pageSize),
  };
};

interface IProps {
  page: number;
  setPage: (page: number) => void;
  totalPages: number;
}

const Paginator: React.FunctionComponent<IProps> = ({
  page,
  setPage,
  totalPages,
}) => {
  const { t } = useTranslation();
  return (
    <Flex>
      <PaginatorButton
        actionMe={() => setPage(1)}
        label={t("paginator.first", "First")}
        disabled={page === 1}
        isSmall={true}
      >
        <ArrowLeftDouble fill="primary" />
      </PaginatorButton>
      <PaginatorButton
        actionMe={() => setPage(page - 1)}
        label={t("paginator.previous", "Previous")}
        disabled={page === 1}
      >
        <ArrowLeft fill="primary" />
      </PaginatorButton>
      <div>
        <strong>{page}</strong> of {totalPages}
      </div>
      <PaginatorButton
        actionMe={() => setPage(page + 1)}
        label={t("paginator.next", "Next")}
        disabled={page === totalPages}
      >
        <ArrowRight fill="primary" />
      </PaginatorButton>
      <PaginatorButton
        actionMe={() => setPage(totalPages)}
        label={t("paginator.last", "Last")}
        disabled={page === totalPages}
        isSmall={true}
      >
        <ArrowRightDouble fill="primary" />
      </PaginatorButton>
    </Flex>
  );
};

export default Paginator;
